<div id="wrapper">
  <edc-demo-access-denied-banner *ngIf="isUnauthorized" resourceName="contracts" details="Please sign in with an account that has access, or ask an admin to grant permissions."></edc-demo-access-denied-banner>
  
  <ng-container *ngIf="!isUnauthorized">
    <div class="search-pagination-container">
      <mat-form-field class="search-form-field" color="accent">
        <mat-label>Search contracts</mat-label>
        <input (input)="onSearch()" [(ngModel)]="searchText" matInput [disabled]="isUnauthorized">
        <mat-icon matPrefix>search</mat-icon>
        <button (click)="searchText=''; onSearch()" *ngIf="searchText && !isUnauthorized" mat-icon-button matSuffix>
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
  
      <mat-paginator
        [length]="paginationState.filteredList.length"
        [hidePageSize]="false"
        [pageIndex]="paginationState.pageIndex"
        [pageSize]="paginationState.pageSize"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
      />
    </div>

  <div fxLayout="row wrap" fxLayoutAlign="start start">
    <mat-card *ngFor="let contract of paginationState.pagedList" class="contract-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>attachment</mat-icon>
        <mat-card-title>{{contract.id ?? contract["@id"]}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-list>
          <!-- asset -->
          <mat-list-item>
            <mat-icon mat-list-icon>category</mat-icon>
            <div class="contract-property-header" matListItemTitle>Asset</div>
            <div 
              class="contract-property-value overflow-ellipsis"
              matListItemLine
              #assetIdDiv
              [matTooltip]="utilService.shouldShowTooltip(assetIdDiv, contract.assetId) ? contract.assetId : ''"
              matTooltipPosition="below"
              matTooltipClass="tooltip"
            >
              {{contract.assetId}}
            </div>
          </mat-list-item>

          <mat-list-item *ngIf="contract.contractOffer?.properties.baseUrl">
            <mat-icon mat-list-icon>http</mat-icon>
            <div class="contract-property-header" matListItemTitle>Base Url</div>
            <div 
              class="contract-property-value overflow-ellipsis"
              matListItemLine
              #baseUrlDiv
              [matTooltip]="utilService.shouldShowTooltip(baseUrlDiv, contract.contractOffer!.properties.baseUrl) ? contract.contractOffer!.properties.baseUrl : ''"
              matTooltipPosition="below"
              matTooltipClass="tooltip"
            >
              {{contract.contractOffer!.properties.baseUrl}}
            </div>
          </mat-list-item>

          <!-- provider -->
          <mat-list-item>
            <mat-icon mat-list-icon>person</mat-icon>
            <div class="contract-property-header" matListItemTitle>Provider</div>
            <div class="contract-property-value" matListItemLine>{{contract.providerId}}</div>
          </mat-list-item>

          <!-- sign date -->
          <mat-list-item>
            <mat-icon mat-list-icon>draw</mat-icon>
            <div class="contract-property-header" matListItemTitle>Signing date</div>
            <div class="contract-property-value" matListItemLine>{{getContractSigningDate(contract)}}</div>
          </mat-list-item>

          <mat-divider inset></mat-divider>
          <mat-card-actions class="card-actions">
            <button (click)="onTransferClicked(contract)" [disabled]="isTransferInProgress(contract.id ?? contract['@id'])" color="accent"
                    mat-stroked-button>
              <mat-icon>downloading</mat-icon>
              Transfer
            </button>
            <button
              [disabled]="!shouldDisplayMetadata(contract.contractOffer!)"
              (click)="onSelect(contract.contractOffer!)" 
              color="white" 
              mat-stroked-button
            >
              <mat-icon>view_list</mat-icon>
              <h3>Display additional metadata</h3>
            </button>
          </mat-card-actions>
          <mat-card-footer class="contract-card-footer">
            <mat-progress-bar *ngIf="isTransferInProgress(contract.id ?? contract['@id'])" color="accent" mode="indeterminate"></mat-progress-bar>
          </mat-card-footer>

        </mat-list>
      </mat-card-content>
    </mat-card>
  </div>
  </ng-container>
</div>
